module.exports = __webpack_public_path__ + "img/logo-3.55399dab.svg";